import React, { useState } from 'react';
import { Dialog, IconButton, Avatar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import styled from 'styled-components';
import ButtonComponent from './buttton';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../Components/modals/DeleteModal';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { Box } from 'lucide-react';
import { margin } from 'polished';

const SideDrawer = styled(Dialog)`
  .MuiDialog-paper {
    position: fixed;
    right: 0;
    top: 0;
    margin: 0;
    height: 100vh;
    max-height: 100vh;
    max-width: 400px;
    width: 400px;
    border-radius: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  @media (max-width: 768px) {
    .MuiDialog-paper {
      width: 100%;
      max-width: 100%;
    }
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 80px;
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const ModalHeader = styled.div`
  padding: 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Urbanist';
  font-size: 20px;
  font-weight: 600;
`;

const ProfileSection = styled.div`
  text-align: center;
  padding: 10px;
  background: white;
`;

const BossName = styled.h3`
  font-family: 'Urbanist';
  font-size: 16px;
  font-weight: 600;
`;

const LinkedInButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border: 1px solid #000000;
  border-radius: 16px;
  background: white;
  color: #000000;
  cursor: pointer;
  font-family: 'Urbanist', sans-serif;
  font-size: 13px;
  font-weight: 500;
  
  &:hover {
    background: #f0f8ff;
  }

  svg:first-child {
    font-size: 14px;
    color: #2B73EF;
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 16px;
  gap: 16px;
  margin: 0px 15px;  
  background: #fff;
  border-radius: 12px;
  box-shadow: -1.186px 1.186px 7.113px rgba(0, 0, 0, 0.12);
  border: 1px solid #E0E0E0;
`;

const InfoItem = styled.div``;
const InfoLabel = styled.div`
  font-size: 11px;
  color: #666;
  margin-bottom: 4px;
  font-family: 'Urbanist';
`;
const InfoValue = styled.div`
  font-size: 13px;
  font-family: 'Urbanist';
  font-weight: 500;
`;

const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 17px;
  font-family: 'Urbanist';
  color: #181C23;
`;


const ContentSection = styled.div`
  padding: 16px;
  margin: 15px 16px;
  border-radius: 12px;
  background-color: #FFF;
  box-shadow: -1.333px 1.333px 8px 0px rgba(0, 0, 0, 0.12);
  font-family: 'Urbanist', sans-serif;
  border: 1px solid #E0E0E0;
`;


const ContentItem = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const ItemTitle = styled.h5`
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-family: 'Urbanist';
  margin: 0 0 8px 0;
  color: #181818;
`;

const ItemText = styled.p`
  font-size: 13px;
  font-family: 'Urbanist';
  color: #666;
  margin: 0;
  line-height: 1.4;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  max-width: 100%; 
`;


const ActionButtons = styled.div`
  position: sticky;
  bottom: 0;
  right: 0;
  width: 400px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  background: transparent;
  z-index: 1;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const RecommendationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
`;

const RecommenderName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #000;
`;

const TimeStamp = styled.div`
  font-size: 12px;
  color: #666;
`;


const NominatorTag = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #444;
  margin: 12px 0;
  gap: 4px;
`;



const NominatorText = styled.span`
  font-size: 14.799px;
  color: #292929;
  font-family: 'Urbanist';
`;

const StrengthsList = styled.div`
  margin-top: 8px;
`;

const StrengthItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 12px;
  color: #000000;
  font-family: 'Urbanist';
  
  &:before {
    content: "•";
    color: #000000;
  }
`;

const BossDetailsModal = ({
  open,
  onClose,
  bossDetails,
  viewType,
  onApprove,
  onReject,
}) => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);  // Set loading to true before API call
    try {
      const bossId = bossDetails._id;
      const info = JSON.parse(localStorage.getItem("info"));
      await axios.delete(
        `https://bossess-backend-e593ba220e57.herokuapp.com/boss/deleteBoss/${bossId}?userId=${info.userId}`,
        { headers: { Authorization: `Bearer ${info.token}` } }
      );
      toast.success("Boss deleted successfully");
      setOpenModal(false);
      onClose();
      window.location.reload();
    } catch (err) {
      toast.error("Delete failed");
    } finally {
      setDeleteLoading(false);  // Set loading to false after API call completes
    }
  };

  const renderPending = () => (
    <ContentSection>
      <SectionTitle>Recommendation Submitted</SectionTitle>

      <RecommendationHeader>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <RecommenderName>{bossDetails?.userName}</RecommenderName>
          <TimeStamp>{moment(bossDetails?.createdAt).fromNow()}</TimeStamp>
        </div>
        <LinkedInButton
          as="a"
          href={bossDetails?.userProfileUrl || bossDetails?.profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            // Prevent default only if we need to handle it programmatically
            if (!bossDetails?.userProfileUrl && !bossDetails?.profileUrl) {
              e.preventDefault();
            }
          }}
          style={{
            display: 'inline-flex',
            textDecoration: 'none',
            cursor: (bossDetails?.userProfileUrl || bossDetails?.profileUrl) ? 'pointer' : 'not-allowed',
            opacity: (bossDetails?.userProfileUrl || bossDetails?.profileUrl) ? 1 : 0.6
          }}
        >
          <LinkedInIcon sx={{ fontSize: 16 }} />
          LinkedIn
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
            <path d="M9.48143 8.51334C9.40151 8.51318 9.32491 8.48129 9.26848 8.42469C9.21204 8.36809 9.18038 8.29141 9.18044 8.21148L9.18644 3.82127L3.4372 9.5539C3.38055 9.61038 3.30379 9.64205 3.2238 9.64193C3.1438 9.64181 3.06713 9.60993 3.01065 9.55328C2.95417 9.49664 2.9225 9.41987 2.92262 9.33988C2.92273 9.25989 2.95462 9.18322 3.01127 9.12674L8.76052 3.3941L4.3703 3.3874C4.2922 3.38453 4.21827 3.35145 4.16407 3.29515C4.10988 3.23884 4.07965 3.1637 4.07977 3.08555C4.07988 3.0074 4.11032 2.93234 4.16468 2.87619C4.21904 2.82005 4.29307 2.78719 4.37117 2.78455L9.48971 2.79195C9.56964 2.79212 9.64623 2.824 9.70267 2.8806C9.75911 2.9372 9.79077 3.01389 9.7907 3.09381L9.7833 8.21235C9.78313 8.29228 9.75125 8.36887 9.69465 8.42531C9.63805 8.48175 9.56136 8.51341 9.48143 8.51334Z" fill="#181C23" />
          </svg>
        </LinkedInButton>

      </RecommendationHeader>

      <NominatorTag>
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path d="M12.4034 3.89875L13.9079 6.9327C14.1131 7.35503 14.6602 7.76013 15.1219 7.8377L17.8488 8.29451C19.5927 8.58757 20.0031 9.86321 18.7464 11.1216L16.6264 13.2591C16.2673 13.6211 16.0708 14.3193 16.1818 14.8192L16.7888 17.4653C17.2675 19.5597 16.1647 20.37 14.3269 19.2753L11.7708 17.7497C11.3092 17.4739 10.5484 17.4739 10.0782 17.7497L7.52224 19.2753C5.69285 20.37 4.58155 19.5511 5.06027 17.4653L5.66721 14.8192C5.77834 14.3193 5.58173 13.6211 5.22269 13.2591L3.10266 11.1216C1.85458 9.86321 2.25636 8.58757 4.00025 8.29451L6.72723 7.8377C7.1803 7.76013 7.7274 7.35503 7.93256 6.9327L9.43708 3.89875C10.2577 2.2525 11.5913 2.2525 12.4034 3.89875Z" stroke="black" stroke-width="1.28242" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <NominatorText>Nominator's Perspective</NominatorText>
      </NominatorTag>

      <ContentItem>
        <ItemTitle>Why would you recommend this person as a Best Boss?</ItemTitle>
        <ItemText>{typeof bossDetails?.recommendation === 'string' ? bossDetails?.recommendation : '-'}</ItemText>
      </ContentItem>
    </ContentSection>
  );

  return (
    <SideDrawer open={open} onClose={onClose}>
      <ModalHeader>
        <Title>{viewType === "pending-request" ? "Boss Recommendation" : "Boss Details"}</Title>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </ModalHeader>

      <ContentWrapper>
        <ProfileSection>
          <BossName>{bossDetails.bossName}</BossName>
          <LinkedInButton
            as="a"
            href={bossDetails?.profileUrl || bossDetails?.userProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              // Prevent default only if we need to handle it programmatically
              if (!bossDetails?.userProfileUrl && !bossDetails?.profileUrl) {
                e.preventDefault();
              }
            }}
            style={{
              display: 'inline-flex',
              textDecoration: 'none',
              cursor: (bossDetails?.userProfileUrl || bossDetails?.profileUrl) ? 'pointer' : 'not-allowed',
              opacity: (bossDetails?.userProfileUrl || bossDetails?.profileUrl) ? 1 : 0.6
            }}
          >
            <LinkedInIcon /> LinkedIn <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
              <path d="M9.48143 8.51334C9.40151 8.51318 9.32491 8.48129 9.26848 8.42469C9.21204 8.36809 9.18038 8.29141 9.18044 8.21148L9.18644 3.82127L3.4372 9.5539C3.38055 9.61038 3.30379 9.64205 3.2238 9.64193C3.1438 9.64181 3.06713 9.60993 3.01065 9.55328C2.95417 9.49664 2.9225 9.41987 2.92262 9.33988C2.92273 9.25989 2.95462 9.18322 3.01127 9.12674L8.76052 3.3941L4.3703 3.3874C4.2922 3.38453 4.21827 3.35145 4.16407 3.29515C4.10988 3.23884 4.07965 3.1637 4.07977 3.08555C4.07988 3.0074 4.11032 2.93234 4.16468 2.87619C4.21904 2.82005 4.29307 2.78719 4.37117 2.78455L9.48971 2.79195C9.56964 2.79212 9.64623 2.824 9.70267 2.8806C9.75911 2.9372 9.79077 3.01389 9.7907 3.09381L9.7833 8.21235C9.78313 8.29228 9.75125 8.36887 9.69465 8.42531C9.63805 8.48175 9.56136 8.51341 9.48143 8.51334Z" fill="#181C23" />
            </svg>
          </LinkedInButton>
        </ProfileSection>
        
        <InfoGrid>
          <InfoItem>
            <InfoLabel>Company</InfoLabel>
            <InfoValue>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {bossDetails.companyName}
                <a
                  href={bossDetails.companyWebsite}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    textDecoration: 'none'
                  }}
                  title="Visit company website"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                    <path d="M6.63916 2.0553H2.98108C2.65768 2.0553 2.34754 2.18377 2.11886 2.41244C1.89019 2.64111 1.76172 2.95126 1.76172 3.27466V9.37146C1.76172 9.69485 1.89019 10.005 2.11886 10.2337C2.34754 10.4624 2.65768 10.5908 2.98108 10.5908H9.07788C9.40128 10.5908 9.71142 10.4624 9.9401 10.2337C10.1688 10.005 10.2972 9.69485 10.2972 9.37146V5.71338M6.02948 6.32306L11.5166 0.835938M11.5166 0.835938H8.4682M11.5166 0.835938V3.88434" stroke="#181C23" strokeWidth="0.780391" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Industry</InfoLabel>
            <InfoValue>{bossDetails.industry}</InfoValue>
          </InfoItem>
          <InfoItem>
            <InfoLabel>Function</InfoLabel>
            <InfoValue>{bossDetails.function || '-'}</InfoValue>
          </InfoItem>
        </InfoGrid>

        {viewType === "pending-request" ? renderPending() : null}

      </ContentWrapper>
      
      <ActionButtons>
        {viewType === "pending-request" ? (
          <>
            <ButtonComponent name="Approve" onClick={onApprove} styles={{ backgroundColor: "#12188A" }} />
            <ButtonComponent name="Reject" onClick={onReject} styles={{ backgroundColor: "white", color: "#CC0000", border: "1px solid #CC0000" }} />
          </>
        ) : (
          <>
            <ButtonComponent 
              name="View All Recommendations" 
              onClick={() => navigate(`/recommendations/${bossDetails._id}`)} 
              styles={{ 
                backgroundColor: "white", 
                color: "#000", 
                border: "1px solid #000",
                width: '100%',
                marginBottom: '8px'
              }} 
            />
            <ButtonComponent 
              name="Delete Boss" 
              onClick={() => setOpenModal(true)} 
              styles={{ 
                backgroundColor: "#CC0000",
                width: '100%'
              }} 
            />
          </>
        )}
      </ActionButtons>

      <DeleteModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onDelete={handleDelete}
        isDeleting={deleteLoading}
        deleteButtonText="Delete Boss"
        title="Are You Sure You Want to Delete This Boss?"
        description="This will permanently remove the boss and all associated recommendations from the platform. This action cannot be undone."
      />
    </SideDrawer>
  );
};

export default BossDetailsModal;